import { render } from "./Staff.vue?vue&type=template&id=6e249366&scoped=true"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"

import "./Staff.vue?vue&type=style&index=0&id=6e249366&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/takayama_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e249366"]])

export default __exports__